import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { Sgke101aResponseSearchResultList } from 'sg-api';

@Component({
  selector: 'app-sgke100d-result',
  templateUrl: './sgke100d-result.component.html',
  styleUrl: './sgke100d-result.component.scss'
})
export class Sgke100dResultComponent implements OnInit, OnDestroy {

  /** 速報取消・速報取消承認フラグ */
  @Input() isApproval = false;
  /** データソース */
  dataSource: MatTableDataSource<Sgke101aResponseSearchResultList>;
  /** 表データ */
  @Input() responseList: Array<Sgke101aResponseSearchResultList>;
  /** 選択した行の情報 */
  selection: SelectionModel<Sgke101aResponseSearchResultList>;

  /** 登録ボタン押下Emitter */
  @Output() onClickRegistEmitter = new EventEmitter();
  /** 承認ボタン押下Emitter */
  @Output() onClickApplovalEmitter = new EventEmitter();
  /** 行選択Emitter */
  @Output() selectionEmitter = new EventEmitter<SelectionModel<Sgke101aResponseSearchResultList>>();

  /** ソート */
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  /** ページネイター */
  @ViewChild('paginator1', { static: true }) paginator: MatPaginator;

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'select',
    'payCtrNo',
    'visitName',
    'realtimetorikeshiJsnYearmonthdate',
    'cvsCompanyname',
    'claimYmt',
    'rcvmnyNo',
    'rcvmnyYearmonthdate',
    'inmny',
    'kinko',
    'receivablerefresh'
  ];

  /**
   * コンストラクタ
   * @memberof Sgke100dResultComponent
   */
  constructor(
  ) {
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<Sgke101aResponseSearchResultList>(this.responseList);
    this.selection = new SelectionModel<Sgke101aResponseSearchResultList>(true, []);
    // 表データと、ソート/ページングを連携
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  ngOnDestroy() {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 行選択を親コンポーネントへ通知する処理
   *
   * @param {Sgke101aResponseSearchResultList} row
   * @memberof Sgke100dResultComponent
   */
  selectionToggle(row: Sgke101aResponseSearchResultList) {
    this.selection.toggle(row)
  }

  /**
   * 登録ボタン押下を親コンポーネントへ通知する処理
   *
   * @memberof Sgke100dResultComponent
   */
  onClickRegist(): void {
    this.onClickRegistEmitter.emit(this.selection.selected);
  }

  /**
   * 承認ボタン押下を親コンポーネントへ通知する処理
   *
   * @memberof Sgke100dResultComponent
   */
  onClickApploval(): void {
    this.onClickApplovalEmitter.emit(this.selection.selected);
  }

  /**
   * 受付基盤 入金情報照会画面への遷移
   *
   * @param {Sgke101aResponseSearchResultList} row
   * @param {MouseEvent} [event]
   * @memberof Sgke100dResultComponent
   */
  onDblClickRow(row: Sgke101aResponseSearchResultList, event?: MouseEvent) {

    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;

    // anyタイプのパラメータ
    let paramToOutside: any = {};

    // お客さま番号
    let customerNo: string = row.visitornumber;
    // 支払契約番号
    let paymentContractNo: string = row.payCtrNo;
    // 入金番号
    let paymentNo: string = row.rcvmnyNo;

    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 入金番号
    if (paymentNo) {
      paramToOutside.c__paymentNo = paymentNo;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = '6';

    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };

    // 別タブで該当URLを開く	
    window.open(`${url}${params}`, '_blank');

  };

}

